import React, {memo} from "react";

const BackgroundLetters = memo(({count = 28}) => {
    // Статичные звёзды не отвлекают от игрового поля и не зависят от перерисовки React.
    const stars = Array.from({length: count}, (_, index) => ({
        left: `${(index * 37) % 100}%`,
        top: `${(index * 61) % 100}%`,
        opacity: 0.2 + (index % 4) * 0.15,
    }));

    return (
        <div
            className="app-background-letters"
            aria-hidden="true"
        >
            {stars.map((star, index) => (
                <div
                    key={index}
                    className="app-background-letters__item"
                    style={{
                        left: star.left,
                        top: star.top,
                        opacity: star.opacity,
                    }}
                />
            ))}
        </div>
    );
});

export default BackgroundLetters;
